import DestinationCardInformative from './DestinationCardInformative';

export default DestinationCardInformative;
